import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, renderSlot } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaList"
  },
  __name: "VaList",
  props: {
    ...useComponentPresetProp,
    fit: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const computedClass = computed(() => ({ "va-list--fit": props.fit }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["va-list", computedClass.value]),
        role: "list"
      }, [
        renderSlot(_ctx.$slots, "default")
      ], 2);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaList.css';
//# sourceMappingURL=VaList.vue_vue_type_script_setup_true_lang.js.map
